module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic.156f6852.woff2";